// External Dependencies
import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'react-router';

// Internal Dependencies
import EnhancedMenuItem from '../enhanced-menu-item';

// Local Variables
const propTypes = {
  count: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  icon: PropTypes.func,
  iconColor: PropTypes.string,
  iconTooltip: PropTypes.string,
  icons: PropTypes.arrayOf(PropTypes.element),
  isLoading: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  router: PropTypes.object.isRequired,
  text: PropTypes.node.isRequired,
  url: PropTypes.string,
};

const defaultProps = {
  count: null,
  disabled: false,
  icon: null,
  iconColor: '',
  iconTooltip: null,
  icons: [],
  isLoading: false,
  url: '',
};

// Component Definition
export const NavMenuItem = (props) => {
  const {
    count,
    disabled,
    icon,
    iconColor,
    iconTooltip,
    icons,
    isLoading,
    router,
    text,
    url,
    ...other
  } = props;

  const isActive = Boolean(url && router.isActive(url));

  return (
    <Link to={url} {...other}>
      <EnhancedMenuItem
        count={count}
        disabled={disabled}
        icon={icon}
        iconColor={iconColor}
        iconTooltip={iconTooltip}
        icons={icons}
        isActive={isActive}
        isLoading={isLoading}
        text={text}
      />
    </Link>
  );
};

NavMenuItem.propTypes = propTypes;
NavMenuItem.defaultProps = defaultProps;
export default withRouter(NavMenuItem);



/** WEBPACK FOOTER **
 ** ./src/shared/nav-menu-item/index.js
 **/